import { AutocompleteOption, LwFormDate, LwFormSelect } from 'redesign';
import { Box, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { DateTime } from 'luxon';
import { WorkerList } from 'hq/services/flex-worker-service.types';
import { Section } from 'shared/components/common/form-section';
import { useTranslation } from 'react-i18next';
import { FlexWorkerSelect, FlexWorkerSelectStateProps } from '../../flexWorkers/flex-worker-select';
import { DocumentType } from '../documents-page/table/documents-table.types';

export type DocumentFormTypes = {
  documentType: DocumentType | null;
  startDate: string | null;
  endDate: string | null;
  flexWorkerOption: AutocompleteOption | null;
};

type DocumentFormProps = FlexWorkerSelectStateProps & {
  flexWorkers: WorkerList[];
  formState: 'create';
};

export const DocumentFormHQ = (props: DocumentFormProps) => {
  const { t } = useTranslation(['hq-screen-specific', 'web-common']);
  const formMethods = useFormContext<DocumentFormTypes>();

  const documentTypeOptions = [
    {
      value: DocumentType.EMPLOYER_CONTRACT,
      label: t('document_form.labour_contract_a', { ns: 'hq-screen-specific' }),
    },
  ];

  return (
    <Box width={'100%'}>
      <Grid container>
        <Section sectionLabel={t('flex_worker_select_section.title', { ns: 'hq-screen-specific' })}>
          <Grid item xs={6}>
            <FlexWorkerSelect
              workers={props.flexWorkers}
              flexWorkerOption={props.flexWorkerOption}
              flexWorkerSearch={props.flexWorkerSearch}
              setFlexWorkerSearch={props.setFlexWorkerSearch}
              setFlexWorkerOption={props.setFlexWorkerOption}
            />
          </Grid>
        </Section>
        <Section
          sectionLabel={t('document_form.document_details_section_title', {
            ns: 'hq-screen-specific',
          })}
        >
          <Grid item xs={6}>
            <Box display="flex" flex={1}>
              <LwFormSelect
                control={formMethods.control}
                name="documentType"
                label={t('table_headers.document_type', { ns: 'web-common' })}
                defaultLabel={t('document_form.select_document_type', { ns: 'hq-screen-specific' })}
                options={documentTypeOptions}
                onChange={(e) => {
                  formMethods.setValue('documentType', e.target.value);
                }}
                rules={{ required: true }}
              />
            </Box>
          </Grid>

          <Grid container item xs={12} spacing={4}>
            <Grid item xs={6}>
              <LwFormDate
                name="startDate"
                label={t('select.start_date', { ns: 'web-common' })}
                control={formMethods.control}
                minDate={DateTime.now().toISODate()}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <LwFormDate
                name="endDate"
                label={t('select.end_date', { ns: 'web-common' })}
                control={formMethods.control}
                minDate={DateTime.now().toISODate()}
              />
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Box>
  );
};
